import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

export default function FadeSlideIn({ children, delay = 0, y = 40 }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.15 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay }}
      style={{ willChange: 'transform', overflowX: 'hidden' }} // helpful safety
    >
      {children}
    </motion.div>
  );
}
